import { useState } from "react";
import { useNavigate } from "react-router-dom";

import AVIcon from "../../../components/icons/AllVoicedIcons";
import {
  ApplicationButton,
  ApplicationSectionHeader,
  ApplicationSurface,
} from "../../../components/application";
import {
  readDashboardOrientationNoticeDismissed,
  writeDashboardOrientationNoticeDismissed,
} from "./dashboardOrientationNoticeStorage";

export default function DashboardOrientationNotice() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() =>
    readDashboardOrientationNoticeDismissed()
  );

  if (dismissed) {
    return null;
  }

  return (
    <ApplicationSurface
      ariaLabelledby="dashboard-orientation-notice-title"
      className="av-dashboard-orientation-notice"
      elevation="raised"
      variant="action"
    >
      <div className="av-dashboard-orientation-notice__layout">
        <div aria-hidden="true" className="av-app-icon-badge">
          <AVIcon icon="book" size={24} />
        </div>

        <ApplicationSectionHeader
          title="Getting oriented"
          titleId="dashboard-orientation-notice-title"
          description="All-Voiced has a new organization. The guide explains how the app is structured and where familiar activities and previous pathways can now be found."
        />
      </div>

      <div className="av-dashboard-orientation-notice__actions">
        <ApplicationButton
          onClick={() => navigate("/app/guide")}
        >
          Open the guide
        </ApplicationButton>
        <ApplicationButton
          onClick={() => {
            writeDashboardOrientationNoticeDismissed();
            setDismissed(true);
          }}
          variant="secondary"
        >
          Dismiss
        </ApplicationButton>
      </div>
    </ApplicationSurface>
  );
}
